import { defineMessages } from 'react-intl';

const translations = {
  actions: {
    save: {
      id: 'actions.save',
      defaultMessage: 'Save',
      description: 'Label of the save action',
    },
  },
  properties: {
    position: {
      id: 'properties.position',
      defaultMessage: 'Position',
      description: 'Label of the property position',
    },
  },
  positionDialog: {
    title: {
      id: 'itemQuantityDialog.positionDialog.title',
      defaultMessage: 'Confirm position',
      description: 'Title of the position dialog in the item quantity dialog',
    },
  },
};

export default defineMessages(translations);
